import { css } from '@emotion/css';

export const dialogStyles = css`
  width: 52rem;
  height: 60rem;
`;
